export default __webpack_public_path__ + "static/step1-fdfbf2f9330918e1a0cbd834491bfdf3.jpg";